import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'fd-multiple-text-field',
    templateUrl: './fd-multiple-text-field.component.html',
    styleUrls: ['./fd-multiple-text-field.component.scss'],
    standalone: false
})
export class FdMultipleTextFieldComponent implements OnInit {
  @Input() placeholder = '';
  @Input() items: string[] = [];
  @Output() itemsChange = new EventEmitter<string[]>();
  @ViewChild('inputField') inputField!: ElementRef;
  novaString: string = '';

  constructor() { }

  ngOnInit(): void {
  }

  get addButtonDisabled() {
    return this.items.length == 10;
  }

  addNewItem() {
    if (this.addButtonDisabled) {
      return;
    }

    if (this.novaString.trim()) {
      this.items.push(this.novaString);
      this.novaString = '';
      this.itemsChange.emit(this.items);
    }
    setTimeout(() => {
      this.inputField.nativeElement.focus();
    });
  }

  removerString(index: number) {
    this.items.splice(index, 1);
  }

  onEditChange(index, value) {
    this.items[index] = value;
    this.itemsChange.emit(this.items);
  }

}
